<template>
  <div>
    <modal
      class="editCreditLimit"
      name="dateModal"
      transition="pop-out"
      :width="modalWidth"
      :height="400"
    >
      <div class="text-center py-5">
        <h4>{{ $t("text.bManualRec.selectReportDate") }}</h4>
      </div>
      <div class="sign_up_form_section">
        <form>
          <div class="row justify-content-center">
            <div class="col-md-7">
              <div class="price_change_input_wrapper" ref="e_div">
                <input type="date" :max="maxDate" v-model="date" />
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <div
              class="date-buttons row justify-content-center"
              v-if="!showLoader"
            >
              <div class="col-md-3 progress-btns">
                <button class="cancel" @click="cancel($event)">
                  {{ $t("text.actionButtons.cancel") }}
                </button>
              </div>
              <div class="col-md-3 progress-btns">
                <button
                  class="ok"
                  @click="dateOk($event)"
                  :disabled="date === '' ? true : false"
                  :style="[
                    date === ''
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.actionButtons.ok") }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </modal>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="col-md-12 manual_record">
          <div class="header row">
            <div class="left img-container">
              <img src="@/assets/img/Group_10680.svg" />
            </div>

            <div class="left page-desc">
              <h4 class="page-header">
                {{ $t("text.bManualRec.title") }} -
                {{ !date ? "" : $moment(date).format("MMMM D, YYYY") }}
              </h4>
              <p class="page-desc">
                {{ $t("text.bManualRec.description") }}
              </p>
            </div>
          </div>
          <br class="clear" />
          <div class="display-flex align-items-center w-100 progress-wrapper">
            <div class="position-relative w-100 highchart-container row">
              <highcharts
                :options="circularProgressBar"
                class="progress-highchart"
              ></highcharts>
              <div class="m-progress-name">
                <div>
                  {{ steps.length ? steps[step].name : "" }} ({{ step }} /
                  {{ steps.length }})
                </div>
              </div>
            </div>
          </div>

          <div class="body row">
            <div
              class="col-md-3 desk-progress"
              style="border-right: #fafafa solid 2px"
            >
              <div class="d-stepper">
                <div class="d-stepper-header justify-content-around">
                  <div
                    class="step-number-content text-left"
                    :class="{ active: step >= i }"
                    v-for="(stepItem, i) in steps"
                    :key="i"
                  >
                    <div
                      class="step-number align-items-center justify-content-center mx-auto"
                      :class="stepNumberClasses(i)"
                    ></div>
                    <div class="">{{ stepItem.name }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-md-9 progress-content"
              style="padding: 0 !important"
            >
              <!-- <div
                v-if="(!showLoader && manualPumps.length < 1 )"
                  class="empty-info-wrapper new-row " >
                  <h6 class="light-grey-text font-bold">
                      No manual records set yet
                  </h6>
                  <div class="mt-5"></div>
              </div> -->
              <div class="header-title" v-if="!showLoader">
                <div v-if="steps[step].name === $t('text.bMasterLayout.pumps')">
                  <div
                    class="item"
                    :class="{ active: pumpIndex >= i }"
                    v-for="(pump, i) in pumps"
                    :key="i"
                  >
                    <p>{{ pump.displayName }}</p>
                  </div>

                  <div style="clear: both"></div>
                </div>

                <div
                  v-else-if="
                    steps[step].name === $t('text.bMasterLayout.tanks')
                  "
                >
                  <div
                    class="item"
                    :class="{ active: tankIndex >= i }"
                    v-for="(tank, i) in tanks"
                    :key="i"
                  >
                    <p>{{ tank.name }}</p>
                  </div>

                  <div style="clear: both"></div>
                </div>

                <p class="other-title" v-else>{{ steps[step].name }}</p>
              </div>

              <div
                class="stepper-body row justify-content-around"
                v-if="!showLoader"
              >
                <!-- PUMPS START -->
                <div
                  class="col-md-7"
                  v-if="
                    manualPumps.length > 0 &&
                    steps[step].name === $t('text.bMasterLayout.pumps')
                  "
                >
                  <div>
                    <label
                      >{{
                        showOuterForm
                          ? $t("text.bManualRec.outerMeter")
                          : showInnerForm
                          ? $t("text.bManualRec.innerMeter")
                          : ""
                      }}
                      - {{ manualPumps[pumpIndex].name }}</label
                    >
                    <div
                      class="row meter"
                      v-for="(singleRec, i) in manualPumps[pumpIndex].items"
                      :key="i"
                    >
                      <label
                        class="text-right w-100"
                        v-if="!recordExists"
                        @click="zeroSales(pumpIndex, i)"
                      >
                        <span style="cursor: pointer">
                          {{ $t("text.bManualRec.setZeroSales") }}
                        </span>
                        <span
                          v-if="
                            i !== 0 &&
                            !manualPumps[pumpIndex].disabled &&
                            branchSettings.multipleManualRecord
                          "
                          class="ml-1 text-muted"
                          >|</span
                        >
                        <i
                          v-if="
                            i !== 0 &&
                            !manualPumps[pumpIndex].disabled &&
                            branchSettings.multipleManualRecord
                          "
                          class="fa fa-times fa-lg text-danger cursor-pointer ml-1"
                          @click="
                            deleteRecord(
                              manualPumps[pumpIndex].name,
                              pumpIndex,
                              i
                            )
                          "
                        ></i>
                      </label>

                      <div class="col-md-6">
                        <label
                          >{{ $t("text.bManualRec.openingRead") }}
                          {{ i + 1 }}</label
                        >
                        <input
                          v-if="showOuterForm"
                          type="number"
                          placeholder="0"
                          @input="validate(i)"
                          :disabled="manualPumps[pumpIndex].disabled"
                          v-model="singleRec.outerOpeningRead"
                        />
                        <input
                          v-if="showInnerForm"
                          type="number"
                          placeholder="0"
                          @input="validate(i)"
                          :disabled="manualPumps[pumpIndex].disabled"
                          v-model="singleRec.outerOpeningRead"
                        />
                      </div>

                      <div class="col-md-6">
                        <label
                          >{{ $t("text.bManualRec.closingRead") }}
                          {{ i + 1 }}</label
                        >
                        <input
                          v-if="showOuterForm"
                          type="number"
                          :placeholder="
                            recordExists ? 0 : singleRec.outerOpeningRead
                          "
                          @input="validate(i)"
                          :disabled="manualPumps[pumpIndex].disabled"
                          v-model="singleRec.outerClosingRead"
                        />
                        <input
                          v-if="showInnerForm"
                          type="number"
                          :placeholder="
                            recordExists ? 0 : singleRec.innerOpeningRead
                          "
                          @input="validate(i)"
                          :disabled="manualPumps[pumpIndex].disabled"
                          v-model="singleRec.innerClosingRead"
                        />
                      </div>

                      <span
                        style="
                          margin-top: -20px;
                          width: 100%;
                          text-align: end;
                          margin-right: 20px;
                        "
                      >
                        <label
                          v-if="showOuterForm"
                          :style="{
                            color: singleRec.outerSaleColor,
                          }"
                          >{{ $t("text.bManualRec.totOuterSales") }}:
                          {{ singleRec.outerSale }}</label
                        >
                        <label
                          v-if="showInnerForm"
                          :style="{
                            color: singleRec.innerSaleColor,
                          }"
                          >{{ $t("text.bManualRec.totInnerSales") }}:
                          {{ singleRec.innerSale }}</label
                        >
                      </span>

                      <div class="row">
                        <div class="col-md-6">
                          <label>{{ $t("text.omit.uploadTI") }}</label>

                          <div>
                            <div v-if="singleRec.imageUrl == ''" class="row">
                              <input
                                :class="
                                  imageLoading
                                    ? 'col-md-9 col-sm-9 col-9'
                                    : 'col-md-12 col-sm-12 col-12'
                                "
                                type="file"
                                :ref="'fileInput' + i + pumpIndex"
                                @change="getImageUrl($event, pumpIndex, i)"
                                :disabled="manualPumps[pumpIndex].disabled"
                                accept="image/*"
                                class="form-control-file"
                              />

                              <div
                                v-if="imageLoading"
                                class="col-md-3 col-sm-3 col-3"
                              >
                                <img
                                  src="@/assets/img/git_loader.gif"
                                  width="20px"
                                  class="ml-2"
                                />
                              </div>
                            </div>

                            <div
                              v-if="singleRec.imageUrl !== ''"
                              class="p-1 d-flex justify-content-center align-items-center"
                            >
                              <img
                                :src="singleRec.imageUrl"
                                alt="Selected Image"
                                style="max-height: 45px"
                                :style="
                                  !manualPumps[pumpIndex].disabled
                                    ? 'cursor: pointer'
                                    : ''
                                "
                                class="border border-warning rounded w-100"
                                @click="
                                  !manualPumps[pumpIndex].disabled
                                    ? removeImage($event, pumpIndex, i)
                                    : ''
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <label>{{ $t("text.bManualRec.rtt") }}</label>
                          <input
                            type="number"
                            placeholder="0"
                            :disabled="manualPumps[pumpIndex].disabled"
                            v-model="singleRec.rtt"
                          />
                          <label
                            style="
                              cursor: pointer;
                              width: 100%;
                              text-align: end;
                            "
                            @click="
                              manualPumps[pumpIndex].showTransfer =
                                !manualPumps[pumpIndex].showTransfer
                            "
                          >
                            {{
                              manualPumps[pumpIndex].showTransfer
                                ? $t("text.omit.hideTransfer")
                                : $t("text.omit.showTransfer")
                            }}
                          </label>
                        </div>
                      </div>

                      <div v-if="manualPumps[pumpIndex].showTransfer">
                        <label>{{ $t("text.bManualRec.trf") }}</label>
                        <input
                          type="number"
                          placeholder="0"
                          :disabled="manualPumps[pumpIndex].disabled"
                          v-model="singleRec.transfer"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- ADD RECORD -->
                  <div
                    v-if="
                      !manualPumps[pumpIndex].disabled &&
                      branchSettings.multipleManualRecord
                    "
                    class="d-flex justify-content-end align-items-center mt-1"
                  >
                    <i
                      class="fa fa-plus-circle fa-lg text-success cursor-pointer"
                      @click="addRecord(pumpIndex)"
                    ></i>
                    <label
                      @click="addRecord(pumpIndex)"
                      class="cursor-pointer ml-1 mt-1"
                      >{{ $t("text.omit.addRec") }}</label
                    >
                  </div>
                </div>
                <!-- PUMPS END -->

                <!-- TANKS -->
                <div
                  class="col-md-6"
                  v-if="
                    manualTanks.length > 0 &&
                    steps[step].name === $t('text.bMasterLayout.tanks')
                  "
                >
                  <div>
                    <label>{{ $t("text.bManualRec.openingDip") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      @input="validateTank"
                      :disabled="manualTanks[tankIndex].disabled"
                      v-model="manualTanks[tankIndex].openingDip"
                    />
                  </div>

                  <div>
                    <label>{{ $t("text.bManualRec.closingDip") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      @input="validateTank"
                      :disabled="manualTanks[tankIndex].disabled"
                      v-model="manualTanks[tankIndex].closingDip"
                    />
                  </div>

                  <div>
                    <label>{{ $t("text.bManualRec.closingDipT") }}</label>
                    <input
                      type="time"
                      placeholder="0"
                      :disabled="manualTanks[tankIndex].disabled"
                      v-model="manualTanks[tankIndex].date"
                    />
                  </div>

                  <div>
                    <label>{{ $t("text.bManualRec.volDisc") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      @input="validateTank"
                      :disabled="manualTanks[tankIndex].disabled"
                      v-model="manualTanks[tankIndex].filledVolume"
                    />
                  </div>
                </div>
                <!-- TANKS End -->

                <!-- EXPENSE -->
                <div
                  class="col-md-12 mt-3"
                  v-show="steps[step].name === $t('text.sales.expense')"
                >
                  <label>
                    {{ $t("text.bManualRec.totEx") }}: {{ totalExpense }}
                  </label>
                  <ejs-grid
                    v-show="!showExpenseLoader"
                    ref="dataGrid"
                    :created="refreshGrid"
                    :allowPaging="true"
                    :allowSorting="true"
                    :toolbarClick="toolbarClick"
                    :pageSettings="pageSettings"
                    :toolbar="toolbar"
                    :searchSettings="search"
                    :locale="usedLang"
                  >
                    <e-columns>
                      <e-column
                        width="40"
                        field="index"
                        headerText="#"
                      ></e-column>
                      <e-column
                        field="date"
                        :format="formatOptions"
                        type="date"
                        width="190"
                        :headerText="$t('text.calendar.date')"
                      ></e-column>
                      <e-column
                        field="expenseCategory"
                        width="180"
                        :headerText="$t('text.categories.category')"
                      ></e-column>
                      <e-column
                        field="description"
                        width="180"
                        :headerText="$t('text.bExpenses.description')"
                      ></e-column>
                      <e-column
                        field="amount"
                        format="N2"
                        width="180"
                        :headerText="$t('text.bExpenses.amount')"
                      ></e-column>
                    </e-columns>
                  </ejs-grid>

                  <TableLoader :showLoader="showExpenseLoader"></TableLoader>
                </div>
                <!-- <div class="col-md-6" v-if="step === 2">
                   <div>
                     <label>Expense Category</label>
                     <select v-model="expenseModel.categoryId" v-required>
                      <option
                        :value="ec.id"
                        :selected="i == 0" 
                        v-for="(ec, i) in expenseCategories"
                        :key="i"
                      >
                        {{ ec.name }}
                      </option>
                    </select>
                   </div>

                   <div>
                    <label>Amount</label>
                    <input type="number" placeholder="0" v-model="expenseModel.amount"/>
                   </div>

                   <div>
                    <label>Description</label>
                    <input type="text" placeholder="" v-model="expenseModel.description"/>
                   </div>
                 </div> -->
                <!-- EXPENSE End -->

                <!-- RETAINERSHIP -->
                <div
                  class="col-md-12 mt-3"
                  v-if="
                    steps[step].name === $t('text.cMasterLayout.retainership')
                  "
                >
                  <ejs-grid
                    v-show="!showRetainershipLoader"
                    ref="retainerShipDataGrid"
                    :created="refreshRetainerGrid"
                    :allowPaging="true"
                    :allowSorting="true"
                    :toolbarClick="retainerToolbarClick"
                    :pageSettings="pageSettings"
                    :toolbar="retainerToolbar"
                    :searchSettings="search"
                    :locale="usedLang"
                  >
                    <e-columns>
                      <e-column
                        width="40"
                        field="index"
                        headerText="#"
                      ></e-column>
                      <e-column
                        field="date"
                        :format="formatOptions"
                        type="date"
                        width="190"
                        :headerText="$t('text.calendar.dateTime')"
                      ></e-column>
                      <e-column
                        field="userName"
                        width="180"
                        :headerText="$t('text.form.user')"
                      ></e-column>
                      <e-column
                        field="productName"
                        width="180"
                        :headerText="$t('text.form.product')"
                      ></e-column>
                      <e-column
                        field="volSoldRetainership"
                        width="180"
                        :headerText="$t('text.form.volume')"
                      ></e-column>
                      <e-column
                        field="amountSoldRetainership"
                        format="N2"
                        width="180"
                        :headerText="$t('text.form.amount')"
                      ></e-column>
                    </e-columns>
                  </ejs-grid>

                  <TableLoader
                    :showLoader="showRetainershipLoader"
                  ></TableLoader>
                </div>
                <!-- RETAINERSHIP End -->

                <!-- POS -->
                <div
                  class="col-md-6 row"
                  v-if="
                    manualPOS.length > 0 &&
                    steps[step].name === $t('text.omit.posTransact')
                  "
                >
                  <div
                    class="col-md-6 col-sm-12"
                    v-for="(pos, i) in manualPOS"
                    :key="i"
                  >
                    <label>{{ pos.terminalNo }}</label>
                    <input type="number" placeholder="0" v-model="pos.amount" />
                  </div>
                </div>
                <!-- POS End -->

                <!-- POS -->
                <div
                  class="col-md-6 row"
                  v-if="steps[step].name === $t('text.omit.moMo')"
                >
                  <div class="col-md-9 col-sm-12">
                    <label>{{ $t("text.bManualRec.mmSales") }}</label>
                    <input
                      type="number"
                      placeholder="0"
                      v-model="mobileMoneySales"
                    />
                  </div>
                </div>
                <!-- POS End -->

                <!-- SUMMARY -->
                <div
                  class="col-md-12"
                  v-if="steps[step].name === $t('text.cBank.summary')"
                >
                  <!-- PUMPS -->
                  <p class="summary-title">
                    {{ $t("text.bManualRec.pumpReading") }}
                  </p>
                  <!-- class="scroller" -->
                  <div>
                    <div
                      class="summary-item"
                      v-for="(pmp, i) in manualPumps"
                      :key="i"
                      @click="!recordExists ? gotoPump(i) : null"
                    >
                      <p class="title">{{ pmp.name }}</p>
                      <div
                        v-if="
                          branchSettings.pumpManualRecording === '' ||
                          branchSettings.pumpManualRecording === 'Inner' ||
                          branchSettings.pumpManualRecording === 'Both'
                        "
                      >
                        <div v-for="(item, i) in pmp.items" :key="i">
                          <p>
                            {{ $t("text.bManualRec.innerOpeningReading") }}:
                          </p>
                          <p>{{ item.innerOpeningRead }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div>
                          <p>
                            {{ $t("text.bManualRec.innerClosingReading") }}:
                          </p>
                          <p>{{ item.innerClosingRead }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div>
                          <p>{{ $t("text.bManualRec.rtt") }} {{ i + 1 }}:</p>
                          <p>{{ item.rtt }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div>
                          <p>{{ $t("text.bManualRec.trf") }} {{ i + 1 }}:</p>
                          <p>{{ item.transfer }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div class="summary-total">
                          <p>{{ $t("text.bManualRec.innerTotSales") }}:</p>
                          <p>
                            {{ item.innerClosingRead - item.innerOpeningRead }}
                          </p>
                          <div style="clear: both"></div>
                        </div>
                      </div>

                      <div
                        v-show="
                          branchSettings.pumpManualRecording === '' ||
                          branchSettings.pumpManualRecording === null ||
                          branchSettings.pumpManualRecording === 'Outer' ||
                          branchSettings.pumpManualRecording === 'Both'
                        "
                        v-for="(item, i) in pmp.items"
                        :key="i"
                      >
                        <div>
                          <p>
                            {{ $t("text.bManualRec.outerOpeningReading") }}
                            {{ i + 1 }}:
                          </p>
                          <p>{{ item.outerOpeningRead }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div>
                          <p>
                            {{ $t("text.bManualRec.outerClosingReading") }}
                            {{ i + 1 }}:
                          </p>
                          <p>{{ item.outerClosingRead }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div>
                          <p>{{ $t("text.bManualRec.rtt") }} {{ i + 1 }}:</p>
                          <p>{{ item.rtt }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div>
                          <p>{{ $t("text.bManualRec.trf") }} {{ i + 1 }}:</p>
                          <p>{{ item.transfer }}</p>
                          <div style="clear: both"></div>
                        </div>
                        <div class="summary-total">
                          <p>
                            {{ $t("text.bManualRec.outerTotSales") }}
                            {{ i + 1 }}:
                          </p>
                          <p>
                            {{
                              convertThousand(
                                item.outerClosingRead - item.outerOpeningRead
                              )
                            }}
                          </p>
                          <div style="clear: both"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- TANKS -->
                  <p class="summary-title">
                    {{ $t("text.bManualRec.tankReading") }}
                  </p>
                  <!-- class="scroller" -->
                  <div>
                    <div
                      class="summary-item"
                      v-for="(tnk, i) in manualTanks"
                      :key="i"
                      @click="gotoTank(i)"
                    >
                      <p class="title">{{ tnk.name }}</p>
                      <div>
                        <p>{{ $t("text.bManualRec.openingDip") }}:</p>
                        <p>{{ tnk.openingDip }}</p>
                        <div style="clear: both"></div>
                      </div>
                      <div>
                        <p>{{ $t("text.bManualRec.closingDip") }}:</p>
                        <p>{{ tnk.closingDip }}</p>
                        <div style="clear: both"></div>
                      </div>
                      <div>
                        <p>{{ $t("text.bManualRec.closingDipT") }}:</p>
                        <p>{{ tnk.date }}</p>
                        <div style="clear: both"></div>
                      </div>
                      <div>
                        <p>{{ $t("text.bManualRec.volDisc") }}:</p>
                        <p>{{ tnk.filledVolume }}</p>
                        <div style="clear: both"></div>
                      </div>
                    </div>
                  </div>

                  <p class="summary-title">
                    {{ $t("text.bManualRec.otherSummary") }}
                  </p>
                  <div>
                    <div class="summary-item" @click="gotoExpense()">
                      <p class="title">{{ $t("text.bManualRec.totEx") }}</p>

                      <p>{{ totalExpense }}</p>
                    </div>

                    <div class="summary-item" @click="gotoRetainership()">
                      <p class="title">
                        {{ $t("text.bManualRec.totRetSales") }}
                      </p>

                      <p>{{ totalRetainership }}</p>
                    </div>

                    <div class="summary-item" @click="gotoPosSales()">
                      <p class="title">
                        {{ $t("text.bManualRec.totPOSsales") }}
                      </p>

                      <p>{{ totalPOS }}</p>
                    </div>

                    <div
                      v-if="branchSettings.showMobileMoney"
                      class="summary-item"
                      @click="gotoMobileMoney()"
                    >
                      <p class="title">
                        {{ $t("text.bManualRec.totMMsales") }}
                      </p>

                      <p>{{ mobileMoneySales }}</p>
                    </div>
                  </div>
                </div>
                <!-- SUMMARY End -->
              </div>

              <div
                class="stepper-buttons row justify-content-center"
                v-if="!showLoader && date"
              >
                <div class="col-md-2 progress-btns">
                  <button class="prev" @click="previous()">
                    {{ $t("text.bManualRec.previous") }}
                  </button>
                </div>
                <div class="col-md-2 progress-btns">
                  <button class="next" :disabled="disabled" @click="next()">
                    {{ nextTitle }}
                    <img
                      src="@/assets/img/git_loader.gif"
                      v-show="submitting"
                      width="25px"
                      class="ml-3 loader"
                    />
                  </button>
                </div>
              </div>

              <!-- <TableLoader :showLoader="showLoader" /> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <WarningModal :lastFilledDat="lastFilledDat" :recordDays="recordDays" /> -->
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import TableLoader from "@/components/tableLoader/index";
import configObject from "@/config";
import { Page, Sort, Toolbar, Search, Resize } from "@syncfusion/ej2-vue-grids";
import { Chart } from "highcharts-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import WarningModal from "@/components/modals/ManualRecords/warningModal";

const MODAL_WIDTH = 656;

export default {
  name: "manualRecord",
  components: {
    MasterLayout,
    TableLoader,
    Highcharts: Chart,
    PulseLoader,
    WarningModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, Resize],
  },
  created() {
    document.title = "Manual Record:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Manual Record:: ${branch.name} Retail Outlet`;
    });

    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  watch: {
    // manualTanks(neww) {
    //   console.log(this.manualTanks, "here");
    // },
    step(step) {
      this.circularProgressBar.series[0].data[1].y = Number(
        ((step / 6) * 100).toFixed(2)
      );
      this.circularProgressBar.series[0].data[0].y = Number(
        100 - ((step / 6) * 100).toFixed(2)
      );
      // this.circularProgressBar.subtitle.text = `<div style="margin-top: 25px; padding: 3px">${step} / ${this.steps.length} </div>`
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.$modal.show("dateModal");
          this.getTanks();
          this.getPOSTerminals();
          this.getBranchSettings();
        }
      }
    },
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      circularProgressBar: {
        chart: {
          type: "pie",
          width: 360,
          height: 80,
          spacingTop: 10,
          spacingLeft: -40,
          spacingRight: 210,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: ``,
          align: "center",
          verticalAlign: "middle",
          style: {
            fontSize: "12px",
            textAlign: "center",
          },
          x: 0,
          y: -2,
          useHTML: true,
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ["50%", "50%"],
            dataLabels: {
              enabled: false,
            },
            states: {
              hover: {
                enabled: false,
              },
            },
            size: "35%",
            innerSize: "85%",
            borderColor: null,
            borderWidth: 1,
          },
        },
        tooltip: {
          valueSuffix: "%",
        },
        series: [
          {
            type: "pie",
            enableMouseTracking: false,
            innerSize: "80%",
            dataLabels: {
              enabled: false,
            },
            data: [
              {
                y: 83.33,
                color: "#e7eaeb",
              },
              {
                color: "#4C2E73",
                y: 16.67,
              },
            ],
          },
        ],
      },
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      submitting: false,
      disabled: false,
      recordExists: false,
      modalWidth: MODAL_WIDTH,
      date: "",
      stepDegree: 90 + "deg",
      percent: 0,
      maxDate: new Date().toISOString().split("T")[0],
      nextTitle: this.$t("text.iAddOrder.next"),
      pumpIndex: 0,
      tankIndex: 0,
      totalExpense: 0,
      totalRetainership: 0,
      totalPOS: 0,
      mobileMoneySales: 0,
      branch: {},
      branchSettings: {
        showNonWet: false,
        readingForManual: "",
        pumpManualRecording: "Inner",
        showMobileMoney: true,
        branchId: "",
        useCompanySettings: false,
      },
      manualPumps: [],
      manualTanks: [],
      manualPOS: [],
      expenseModel: { paymentMode: "Cash" },
      showLoader: true,
      loadSettings: true,
      showExpenseLoader: true,
      showRetainershipLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Record Expense", "Refresh", "Search"],
      retainerToolbar: ["Refresh", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branchId: null,
      pumps: [],
      tanks: [],
      expenseCategories: [],
      step: 0,
      steps: [],
      allSteps: [
        {
          name: this.$t("text.bMasterLayout.pumps"),
          active: true,
          disabled: false,
        },
        {
          name: this.$t("text.bMasterLayout.tanks"),
          active: false,
          disabled: false,
        },
        {
          name: this.$t("text.sales.expense"),
          active: false,
          disabled: false,
        },
        {
          name: this.$t("text.cMasterLayout.retainership"),
          active: false,
          disabled: false,
        },
        {
          name: this.$t("text.cMasterLayout.dryStock"),
          active: false,
          disabled: false,
        },
        {
          name: this.$t("text.omit.posTransact"),
          active: false,
          disabled: false,
        },
        {
          name: this.$t("text.omit.moMo"),
          active: false,
          disabled: false,
        },
        {
          name: this.$t("text.cBank.summary"),
          active: false,
          disabled: false,
        },
      ],
      loading: false,
      error: false,
      fatalError: false,
      userDetails: JSON.parse(localStorage.getItem("userDetails")),

      file1: [],
      imageLoading: false,
      recordDays: 0,
      lastFilledDate: "",
    };
  },
  computed: {
    showInnerForm() {
      return (
        this.branchSettings.pumpManualRecording === "" ||
        this.branchSettings.pumpManualRecording === "Inner" ||
        this.branchSettings.pumpManualRecording === "Both"
      );
    },
    showOuterForm() {
      return (
        this.branchSettings.pumpManualRecording === "" ||
        this.branchSettings.pumpManualRecording === null ||
        this.branchSettings.pumpManualRecording === "Outer" ||
        this.branchSettings.pumpManualRecording === "Both"
      );
    },
  },
  mounted() {
    // this.step = 3
  },

  methods: {
    showWarningModal() {
      this.$modal.show("warningModal");
    },
    removeImage($event, pumpIndex, i) {
      let dialog = confirm(`Are you sure you want to remove this image?`);
      if (!dialog) {
        return;
      }

      this.manualPumps[pumpIndex].items[i].imageUrl = "";
      this.$refs["fileInput" + i][0].reset();
    },

    getImageUrl($event, pumpIndex, i) {
      const file = $event.target.files[0]; // Accessing the first file

      if (!file) {
        this.manualPumps[pumpIndex].items[i].imageUrl = "";
        this.$refs["fileInput" + i + pumpIndex].value = null; // Reset the file input
        return;
      }

      this.imageLoading = true;
      let formData = new FormData();
      formData.append("file", file); // Append the file to the FormData object

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Utilities/azureupload/${this.$route.query.companyId}`,
          formData,
          configObject.authConfigForUpload()
        )
        .then((response) => {
          this.manualPumps[pumpIndex].items[i].imageUrl = response.data.url;
          this.imageLoading = false;
        })
        .catch((error) => {
          this.imageLoading = false;
          this.manualPumps[pumpIndex].items[i].imageUrl = "";
          this.$refs["fileInput" + i + pumpIndex].value = null; // Reset the file input
          this.$toast.open({
            message: "Error with uploading image, please retry",
            type: "error",
            duration: 3000,
          });
        });
    },

    addRecord(pumpIndex) {
      let recordDate = this.$moment(this.date);

      this.manualPumps[pumpIndex].items.push({
        closingRead: 0,
        date: recordDate,
        // id: "",
        innerClosingRead: 0,
        innerOpeningRead: 0,
        openingRead: 0,
        outerClosingRead: 0,
        outerOpeningRead: 0,
        rtt: 0,
        transfer: 0,
        imageUrl: "",
      });
    },

    deleteRecord(name, pumpIndex, i) {
      // console.log(name, pumpIndex, i);
      if (this.manualPumps[pumpIndex].items.length <= 1) {
        this.$toast.open({
          message: `Can't delete the only record for ${name}`,
          type: "error",
          duration: 3000,
        });

        return;
      }

      let dialog = confirm(
        `Are you sure you want to delete this record for ${name}?`
      );
      if (!dialog) {
        return;
      }

      this.manualPumps[pumpIndex].items.splice(i, 1);
      this.$toast.open({
        message: "Record deleted",
        type: "error",
        duration: 3000,
      });
    },

    findStep(nm) {
      return this.steps.findIndex((e) => e.name === nm);
    },
    getEnabledSteps() {
      let showNonWet = this.branchSettings.showNonWet;
      let showMobileMoney = this.branchSettings.showMobileMoney;

      this.steps = this.allSteps.filter((e) => {
        if (e.name === this.$t("text.cMasterLayout.dryStock")) {
          e.disabled = !showNonWet;
        } else if (e.name === this.$t("text.omit.moMo")) {
          e.disabled = !showMobileMoney;
        }
        return !e.disabled;
      });
    },
    stepNumberClasses(i) {
      return {
        active: this.step >= i && !this.fatalError,
        "bg-danger": this.fatalError && this.step === i,
        "text-primary": this.step < i,
      };
    },
    next() {
      let myStep = this.steps[this.step];
      if (this.step == this.steps.length - 2) {
        this.nextTitle = this.$t("text.actionButtons.submit");
        this.disabled = this.date === "" ? true : this.recordExists;
      }
      switch (myStep.name) {
        case this.$t("text.bMasterLayout.pumps"): {
          if (this.imageLoading == true) {
            this.$toast.open({
              message: "Image still uploading, please wait",
              type: "error",
              duration: 5000,
            });

            return;
          }

          let saleDone = false;
          let iterationStopped = false;

          // Iterate over each item in the items array using a for loop
          for (
            let index = 0;
            index < this.manualPumps[this.pumpIndex].items.length;
            index++
          ) {
            let item = this.manualPumps[this.pumpIndex].items[index];
            let innerSale = parseFloat(item.innerSale);
            let outerSale = parseFloat(item.outerSale);
            let rtt = parseFloat(item.rtt);
            let transfer = parseFloat(item.transfer);

            if (
              this.branchSettings.pumpManualRecording === "" ||
              this.branchSettings.pumpManualRecording === null ||
              this.branchSettings.pumpManualRecording === "Both"
            ) {
              saleDone = innerSale >= 0 && outerSale >= 0;
            } else if (this.branchSettings.pumpManualRecording === "Inner") {
              saleDone = innerSale >= 0;
            } else if (this.branchSettings.pumpManualRecording === "Outer") {
              saleDone = outerSale >= 0;
            }

            if (saleDone) {
              if (innerSale >= rtt + transfer || outerSale >= rtt + transfer) {
                // Check if this is the last item in the items array
                if (
                  index ===
                  this.manualPumps[this.pumpIndex].items.length - 1
                ) {
                  if (this.pumpIndex < this.manualPumps.length - 1) {
                    this.pumpIndex++;
                  } else {
                    this.step++;
                  }
                }
              } else {
                this.$toast.open({
                  message: this.$t("text.bManualRec.rttError"),
                  type: "error",
                  duration: 5000,
                });
                iterationStopped = true;
                break; // Stop the iteration
              }
            } else {
              this.$toast.open({
                // message: this.$t("text.bManualRec.openGreaterClose"),
                message: `opening reading cannot be greater than closing for manual reading ${
                  index + 1
                }`,
                type: "error",
                duration: 5000,
              });
              iterationStopped = true;
              break; // Stop the iteration
            }
          }

          if (iterationStopped) {
            break;
          }

          break;
        }

        // case this.$t("text.bMasterLayout.pumps"): {
        //   let innerSale = parseFloat(
        //     this.manualPumps[this.pumpIndex].innerSale
        //   );
        //   let outerSale = parseFloat(
        //     this.manualPumps[this.pumpIndex].outerSale
        //   );
        //   let rtt = parseFloat(this.manualPumps[this.pumpIndex].rtt);
        //   let transfer = parseFloat(this.manualPumps[this.pumpIndex].transfer);
        //   let saleDone = false;
        //   if (
        //     this.branchSettings.pumpManualRecording === "" ||
        //     this.branchSettings.pumpManualRecording === null ||
        //     this.branchSettings.pumpManualRecording === "Both"
        //   ) {
        //     // console.log(this.manualPumps);
        //     saleDone = innerSale >= 0 && outerSale >= 0;
        //   } else if (this.branchSettings.pumpManualRecording === "Inner") {
        //     saleDone = innerSale >= 0;
        //   } else if (this.branchSettings.pumpManualRecording === "Outer") {
        //     saleDone = outerSale >= 0;
        //   }

        //   if (saleDone) {
        //     if (innerSale >= rtt + transfer || outerSale >= rtt + transfer) {
        //       if (this.pumpIndex < this.manualPumps.length - 1) {
        //         this.pumpIndex++;
        //       } else {
        //         this.step++;
        //       }
        //     } else {
        //       this.$toast.open({
        //         message: this.$t("text.bManualRec.rttError"),
        //         type: "error",
        //         duration: 5000,
        //       });
        //     }
        //   } else {
        //     this.$toast.open({
        //       message: this.$t("text.bManualRec.openGreaterClose"),
        //       type: "error",
        //       duration: 5000,
        //     });
        //   }
        //   break;
        // }
        case this.$t("text.bMasterLayout.tanks"): {
          let opening = parseFloat(this.manualTanks[this.tankIndex].openingDip);
          let closing = parseFloat(this.manualTanks[this.tankIndex].closingDip);
          let discharge = parseFloat(
            this.manualTanks[this.tankIndex].filledVolume
          );
          if (opening + discharge - closing >= 0) {
            if (this.tankIndex < this.manualTanks.length - 1) {
              this.tankIndex++;
            } else {
              this.step++;

              this.getBranchExpenses();
            }
          } else {
            this.$toast.open({
              message: this.$t("text.bManualRec.dipPlusDischargeError"),
              type: "error",
              duration: 5000,
            });
          }
          break;
        }
        case this.$t("text.sales.expense"): {
          this.step++;
          this.getBranchRetainershipSales();
          break;
        }
        case this.$t("text.cMasterLayout.dryStock"):
        case this.$t("text.cMasterLayout.retainership"):
        case this.$t("text.omit.moMo"): {
          this.step++;
          break;
        }
        case this.$t("text.omit.posTransact"): {
          let posSales = 0;
          this.manualPOS.forEach((el) => {
            posSales = parseFloat(posSales + el.amount).toFixed(2);
          });
          this.totalPOS = posSales;
          this.step++;
          break;
        }
        case this.$t("text.cBank.summary"): {
          this.sumbitReport();
          break;
        }
        default:
          break;
      }
    },
    previous() {
      let myStep = this.steps[this.step];
      switch (myStep.name) {
        case this.$t("text.bMasterLayout.pumps"): {
          if (this.pumpIndex > 0) {
            this.pumpIndex--;
          } else {
            // console.log("no previous step")
          }
          break;
        }
        case this.$t("text.bMasterLayout.tanks"): {
          if (this.tankIndex > 0) {
            this.tankIndex--;
          } else {
            this.step--;
          }
          break;
        }
        case this.$t("text.sales.expense"):
        case this.$t("text.cMasterLayout.retainership"):
        case this.$t("text.cMasterLayout.dryStock"):
        case this.$t("text.omit.moMo"): {
          this.step--;
          break;
        }
        case this.$t("text.omit.posTransact"): {
          this.step--;
          this.getBranchExpenses();
          break;
        }
        case this.$t("text.cBank.summary"): {
          this.step--;
          this.nextTitle = this.$t("text.iAddOrder.next");
          this.disabled = false;
          break;
        }
        default:
          break;
      }
    },
    zeroSales(index, i) {
      this.manualPumps[index].items[i].innerClosingRead =
        this.manualPumps[index].items[i].innerOpeningRead;
      this.manualPumps[index].items[i].outerClosingRead =
        this.manualPumps[index].items[i].outerOpeningRead;
      this.manualPumps[index].items[i].innerSale = 0;
      this.manualPumps[index].items[i].outerSale = 0;
      this.manualPumps[index].items[i].innerSaleColor = "#4c2e73 !important";
      this.manualPumps[index].items[i].outerSaleColor = "#4c2e73 !important";
    },
    gotoPump(index) {
      this.pumpIndex = index;
      this.step = 0;
      this.nextTitle = this.$t("text.iAddOrder.next");
      this.disabled = false;
    },
    gotoTank(index) {
      this.tankIndex = index;
      this.step = 1;
      this.nextTitle = this.$t("text.iAddOrder.next");
      this.disabled = false;
    },
    gotoExpense() {
      this.getBranchExpenses();
      this.disabled = false;
      this.nextTitle = this.$t("text.iAddOrder.next");
      this.step = this.findStep(this.$t("text.sales.expense"));
    },
    gotoRetainership() {
      this.getBranchRetainershipSales();
      this.disabled = false;
      this.nextTitle = this.$t("text.iAddOrder.next");
      this.step = this.findStep(this.$t("text.cMasterLayout.retainership"));
    },
    gotoPosSales() {
      this.disabled = false;
      this.nextTitle = this.$t("text.iAddOrder.next");
      this.step = this.findStep(this.$t("text.omit.posTransact"));
    },
    gotoMobileMoney() {
      this.disabled = false;
      this.nextTitle = this.$t("text.iAddOrder.next");
      this.step = this.findStep(this.$t("text.omit.moMo"));
    },
    validate(i) {
      let innerOpening =
        this.manualPumps[this.pumpIndex].items[i].innerOpeningRead;
      let innerClosing =
        this.manualPumps[this.pumpIndex].items[i].innerClosingRead;
      let outerOpening =
        this.manualPumps[this.pumpIndex].items[i].outerOpeningRead;
      let outerClosing =
        this.manualPumps[this.pumpIndex].items[i].outerClosingRead;

      let innerSale;

      if (
        this.branchSettings.pumpManualRecording === "" ||
        this.branchSettings.pumpManualRecording === null ||
        this.branchSettings.pumpManualRecording === "Both"
      ) {
        innerSale = 0;
      } else {
        innerSale = innerClosing - innerOpening;
      }
      // let innerSale = innerClosing - innerOpening;
      let outerSale = outerClosing - outerOpening;

      this.manualPumps[this.pumpIndex].items[i].innerSale = innerSale;
      this.manualPumps[this.pumpIndex].items[i].outerSale = outerSale;

      if (outerSale < 0) {
        this.manualPumps[this.pumpIndex].items[i].outerSaleColor =
          "red !important";
      } else {
        this.manualPumps[this.pumpIndex].items[i].outerSaleColor =
          "#4c2e73 !important";
      }

      if (innerSale < 0) {
        this.manualPumps[this.pumpIndex].items[i].innerSaleColor =
          "red !important";
      } else {
        this.manualPumps[this.pumpIndex].items[i].innerSaleColor =
          "#4c2e73 !important";
      }
    },
    validateTank() {},
    getBranchSettings() {
      this.loadSettings = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/LoadSettings/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          let setting = response.data;
          if (setting != null) {
            this.branchSettings = setting;
          }

          // let setting = response.data;
          // if(setting != null){
          //   if(setting.branchSetting != null && !setting.branchSetting.useCompanySettings){
          //       this.branchSettings = setting.branchSetting;
          //   }
          //   else{
          //     this.branchSettings = setting.companySetting;
          //   }
          //   this.branchSettings.useCompanySettings = setting.branchSetting.useCompanySettings
          // }

          this.loadSettings = false;
          this.getEnabledSteps();
        })
        .catch((error) => {
          this.getEnabledSteps();
          this.loadSettings = false;
        });
    },
    getPumps() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) =>
            a.productName.toLowerCase() < b.productName.toLowerCase()
              ? -1
              : a.productName.toLowerCase() > b.productName.toLowerCase()
              ? 1
              : 0
          );

          this.pumps = response.data.filter((el) => {
            return el.name.toLowerCase() !== "cb";
          });

          this.pumps.forEach((el) => {
            let pmp = {
              name: el.displayName,
              pumpId: el.id,
              openingRead: 0,
              closingRead: 0,
              rtt: 0,
            };

            this.manualPumps.push(pmp);
          });

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    RoundToTwoDecimals(num) {
      return Math.round(num * 100) / 100;
    },

    getPumpManualTrans() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/ManualTransaction/${this.branchId}?date=${this.date}`,
          configObject.authConfig()
        )
        .then((response) => {
          // response.data.sort((a, b) =>
          //   a.name.toLowerCase() < b.name.toLowerCase()
          //     ? -1
          //     : a.name.toLowerCase() > b.name.toLowerCase()
          //     ? 1
          //     : 0
          // );

          const cleanedData = response.data;

          // console.log("test", cleanedData);

          cleanedData.sort((a, b) => a.addressId - b.addressId);

          this.pumps = cleanedData.filter((el) => {
            return el.name.toLowerCase() !== "cb";
          });

          let recordDate = this.$moment(this.date);

          const isInner = this.branchSettings.pumpManualRecording === "Inner";

          this.pumps.forEach((el) => {
            let elDate = this.$moment(el.date);
            let recordExists = recordDate <= elDate;

            // LOGIC TO KNOW WHEN PUMP RECORD WAS TAKEN LAST
            // let filledDate = this.$moment(el.lastClosingDate).format(
            //   "YYYY-MM-DD"
            // );
            // let daysDifference =
            //   (new Date(this.date) - new Date(filledDate)) /
            //   (1000 * 60 * 60 * 24);
            // console.log(daysDifference);
            // if (daysDifference >1) {
            //   this.lastFilledDate = filledDate;
            //   this.recordDays = daysDifference;
            //   this.showWarningModal()
            // }

            this.recordExists = recordExists;

            let innerOpeningRead = recordExists
              ? el.innerOpeningRead === null
                ? 0
                : el.innerOpeningRead
              : el.innerClosingRead === null
              ? 0
              : el.innerClosingRead;
            let outerOpeningRead = recordExists
              ? el.outerOpeningRead === null
                ? 0
                : el.outerOpeningRead
              : el.outerClosingRead === null
              ? 0
              : el.outerClosingRead;
            let innerClosingRead =
              !recordExists || el.innerClosingRead === null
                ? 0
                : el.innerClosingRead;
            let outerClosingRead =
              !recordExists || el.outerClosingRead === null
                ? 0
                : el.outerClosingRead;

            // DEFINING DEFAULT DATA FOR EMPTY ITEMS
            let defaultItem = [
              {
                closingRead: 0,
                date: recordDate,
                // id: "",
                innerClosingRead: 0,
                innerOpeningRead: 0,
                openingRead: 0,
                outerClosingRead: 0,
                outerOpeningRead: 0,
                rtt: 0,
                transfer: 0,
                imageUrl: "",
              },
            ];

            // ASSIGNING DEFAULT DATA FOR EMPTY ITEMS
            if (Array.isArray(el.items) && el.items.length === 0) {
              el.items = defaultItem;
              if (isInner) {
                el.items[0].innerOpeningRead = el.lastClosingRead;
              } else {
                el.items[0].outerOpeningRead = el.lastClosingRead;
              }
            }

            el.items.forEach((e) => {
              e.innerOpeningRead = this.RoundToTwoDecimals(e.innerOpeningRead);
              e.innerClosingRead = this.RoundToTwoDecimals(e.innerClosingRead);
              e.outerOpeningRead = this.RoundToTwoDecimals(e.outerOpeningRead);
              e.outerClosingRead = this.RoundToTwoDecimals(e.outerClosingRead);
              e.closingRead = this.RoundToTwoDecimals(e.closingRead);
              e.openingRead = this.RoundToTwoDecimals(e.openingRead);
              e.innerSale = this.RoundToTwoDecimals(
                e.innerClosingRead - e.innerOpeningRead
              );
              e.outerSale = this.RoundToTwoDecimals(
                e.outerClosingRead - e.outerOpeningRead
              );
              e.innerSaleColor =
                e.innerClosingRead - e.innerOpeningRead < 0
                  ? "red !important"
                  : "#4c2e73 !important";
              e.outerSaleColor =
                e.outerClosingRead - e.outerOpeningRead < 0
                  ? "red !important"
                  : "#4c2e73 !important";
              e.imageUrl = e.imageUrl || "";
              e.date = e.date;
            });

            let pmp = {
              name: el.displayName,
              pumpId: el.id,
              items: el.items,
              // innerOpeningRead: innerOpeningRead,
              // innerClosingRead: innerClosingRead,
              // outerOpeningRead: outerOpeningRead,
              // outerClosingRead: outerClosingRead,
              // innerSale: innerClosingRead - innerOpeningRead,
              // outerSale: outerClosingRead - outerOpeningRead,
              // innerSaleColor:
              //   innerClosingRead - innerOpeningRead < 0
              //     ? "red !important"
              //     : "#4c2e73 !important",
              // outerSaleColor:
              //   outerClosingRead - outerOpeningRead < 0
              //     ? "red !important"
              //     : "#4c2e73 !important",
              // rtt: recordExists ? (el.rtt === null ? 0 : el.rtt) : 0,
              // transfer: recordExists
              //   ? el.transfer == null
              //     ? 0
              //     : el.transfer
              //   : 0,
              showTransfer: false,
              disabled: recordExists,
            };

            this.manualPumps.push(pmp);

            this.showLoader = false;
          });

          // console.log(this.manualPumps);

          if (this.recordExists) {
            this.step = 5;
            this.nextTitle = this.$t("text.actionButtons.submit");
            this.disabled = this.date === "" ? true : this.recordExists;
          }
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getTanks() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Tanks/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : 0;
          });

          this.tanks = response.data;

          this.tanks.forEach((el) => {
            let tnk = {
              name: el.name,
              tankId: el.id,
              openingDip: 0,
              closingDip: 0,
              filledVolume: 0,
              date: "",
            };
            const doesExist = this.manualTanks.find((tank) => {
              return tank.name === el.name;
            });
            if (!doesExist) {
              this.manualTanks.push(tnk);
            }
          });

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getTankDippings() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankDippings/${this.branchId}?startDate=${this.date}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) =>
            this.$moment(a.date) < this.$moment(b.date)
              ? -1
              : this.$moment(a.date) > this.$moment(b.date)
              ? 1
              : 0
          );

          let dippings = response.data;
          let recordDate = this.$moment(this.date);

          this.manualTanks.forEach((tk) => {
            dippings.forEach((dp) => {
              if (dp.tankId === tk.tankId) {
                let elDate = this.$moment(dp.date);
                let recordExists = recordDate <= elDate;
                tk.filledVolume = parseFloat(
                  recordExists ? dp.filledVolume : 0
                );
                tk.openingDip = recordExists
                  ? dp.openingDip === null
                    ? 0
                    : dp.openingDip
                  : dp.actualVolume === null
                  ? 0
                  : dp.actualVolume;
                tk.closingDip = dp.actualVolume === null ? 0 : dp.actualVolume;
                tk.date =
                  recordExists && dp.date !== null
                    ? this.$moment(dp.date).format("HH:mm")
                    : "";
                tk.disabled = recordExists;
              }
            });
          });

          this.getTankFills();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getPOSTerminals() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/pos/GetTerminals/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.toLowerCase() > b.toLowerCase()
              ? 1
              : a.toLowerCase() < b.toLowerCase()
              ? -1
              : 0;
          });

          response.data.forEach((el) => {
            let pos = {
              terminalNo: el.toUpperCase(),
              amount: 0,
            };

            this.manualPOS.push(pos);
          });

          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getExpenseCategories() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/branch/ExpenseCategories/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : 0;
          });

          this.expenseCategories = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    dateOk(event) {
      event.preventDefault();
      if (this.date !== "") {
        this.getPumpManualTrans();
        this.getTankDippings();
        this.getBranchExpenses();
        this.$modal.hide("dateModal");
      }
    },
    cancel(event) {
      event.preventDefault();
      if (
        this.userDetails.roles.includes("Sub Branch Manager") &&
        this.userDetails.roles.includes("manualRecords") &&
        !this.userDetails.roles.includes("Branch")
      ) {
        const answer = window.confirm(
          this.$t("text.bMasterLayout.confirmLogout")
        );
        if (answer) {
          this.$modal.hide("dateModal");
          if (localStorage.getItem("locale")) {
            const locale = localStorage.getItem("locale");
            this.$store.commit("setBaseLocale", locale);
          }
          this.$store.commit("setModalShown", false);
          this.$store.commit("setStatusInfo", {});
          this.$store.commit("setBranchModalShown", false);
          this.$store.commit("setBranchStatusInfo", {});

          localStorage.clear();
          this.$router.push({ name: "login" });
        }
      } else {
        this.$modal.hide("dateModal");
        window.history.back();
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    refreshRetainerGrid() {
      this.$refs.retainerShipDataGrid.refresh();
    },
    getBranchExpenses() {
      this.showExpenseLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Expenses/${this.branchId}?startDate=${this.date}&endDate=${this.date}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showExpenseLoader = false;
          let index = 0;
          let exp = 0;
          response.data.forEach((element) => {
            element.index = ++index;
            element.account =
              !element.account || element.account === "undefined"
                ? "N/A"
                : element.account;
            exp += element.amount;
          });

          this.totalExpense = exp;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          // console.log(error);
          this.showExpenseLoader = false;
        });
    },
    getTankFills() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankFills/${this.branchId}?startDate=${this.date}&endDate=${this.date}`,
          configObject.authConfig()
        )
        .then((response) => {
          let tankFills = response.data;

          this.manualTanks.forEach((tk) => {
            tankFills.forEach((tf) => {
              if (tf.tank.toLowerCase() === tk.name.toLowerCase()) {
                tk.filledVolume = (tk.filledVolume + tf.filledVolume).toFixed(
                  2
                );
              }
            });
          });

          this.showLoader = false;
        })
        .catch((error) => {
          // console.log(error);
          this.showExpenseLoader = false;
        });
    },
    getBranchRetainershipSales() {
      this.showRetainershipLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RetainershipSales/${this.branchId}?startDate=${this.date}&endDate=${this.date}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showRetainershipLoader = false;
          let index = 0;
          let retainerShip = 0;
          response.data.forEach((element) => {
            element.index = ++index;
            element.userName =
              element.voucherUser && element.voucherUser !== ""
                ? element.voucherUser
                : element.userName;
            retainerShip = (retainerShip + element.amount).toFixed(2);
          });

          this.totalRetainership = retainerShip;

          this.$refs.retainerShipDataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshRetainerGrid();
        })
        .catch((error) => {
          // console.log(error);
          this.showRetainershipLoader = false;
        });
    },
    convertThousand(request) {
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "Record Expense":
          let routeData = this.$router.resolve({
            name: "expenses",
            query: {
              branchId: this.$route.query.branchId,
              companyId: this.$route.query.companyId,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
              startDate: this.date,
              endDate: this.date,
            },
          });
          window.open(routeData.href, "_blank");
          break;
        case "Refresh":
          this.getBranchExpenses();
          break;
      }
    },
    retainerToolbarClick(args) {
      switch (args.item.text) {
        case "Refresh":
          this.getBranchRetainershipSales();
          break;
      }
    },
    sumbitReport() {
      if (!this.disabled) {
        this.submitting = true;
        this.disabled = true;

        // TAKING OUT UNWANTED DATA
        const isInner = this.branchSettings.pumpManualRecording === "Inner";

        const manualPumpData = this.manualPumps.map(
          ({ name, date, showTransfer, disabled, items, ...rest }) => ({
            ...rest,
            items: items.map(
              ({
                date,
                innerSaleColor,
                outerSaleColor,
                openingRead,
                closingRead,
                innerOpeningRead,
                innerClosingRead,
                outerOpeningRead,
                outerClosingRead,
                ...itemRest
              }) => ({
                ...itemRest,
                outerOpeningRead: isInner
                  ? +innerOpeningRead
                  : +outerOpeningRead,
                outerClosingRead: isInner
                  ? +innerClosingRead
                  : +outerClosingRead,
                innerOpeningRead: isInner
                  ? +innerOpeningRead
                  : +outerOpeningRead,
                innerClosingRead: isInner
                  ? +innerClosingRead
                  : +outerClosingRead,
                openingRead: isInner ? +innerOpeningRead : +outerOpeningRead,
                closingRead: isInner ? +innerClosingRead : +outerClosingRead,
              })
            ),
          })
        );

        // FLATTENING OUT ITEMS ARRAY
        const transformData = (data) => {
          let pumpReading = [];

          data.forEach((pump) => {
            pump.items.forEach((item) => {
              pumpReading.push({
                pumpId: pump.pumpId,
                ...item,
              });
            });
          });

          return pumpReading;
        };

        const transformedData = transformData(manualPumpData);

        // console.log(transformedData);

        const manualTanksData = this.manualTanks.map(
          ({ name, disabled, ...rest }) => ({
            ...rest,
          })
        );

        const data = {
          date: this.date,
          branchId: this.branchId,
          // pumpReading: this.manualPumps,
          pumpReading: transformedData,
          // tankDip: this.manualTanks,
          tankDip: manualTanksData,
          //"expense": this.expenseModel,
          posTrans: this.manualPOS,
        };

        // console.log(data);

        this.axios
          .post(
            `${configObject.apiBaseUrl}/Branch/Summary`,
            data,
            configObject.authConfig()
          )
          .then((response) => {
            this.submitting = false;
            if (response.status <= 200) {
              this.$toast.open({
                message: this.$t("text.bManualRec.summarySuccess"),
                type: "success",
                duration: 5000,
              });
              window.history.back();
            } else {
              this.disabled = false;
              this.$toast.open({
                message: response.statusText,
                type: "error",
                duration: 5000,
              });
            }
          })
          .catch((error) => {
            this.submitting = false;
            this.disabled = false;
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 5000,
            });
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 675px) {
  .desk-progress {
    display: none;
  }

  .date-buttons {
    display: flex;
  }
  .manual_record .header .page-desc {
    width: 85%;
    display: none;
  }
  .progress-content {
    margin-top: -37px;
  }
  .manual_record .body .header-title {
    padding: 10px;
  }
  .progress-btns {
    width: 50% !important;
  }
  .m-progress-name {
    position: absolute;
    top: 25px;
    left: 25%;
    div {
      font-size: 14px;
    }
  }
  .manual_record .header .img-container {
    width: 15%;
  }
  .manual_record .header .left img {
    margin-left: 0px;
    padding: 6px;
  }
  .manual_record .header .left h4 {
    font-size: 14px;
    margin-top: 15px;
  }
  .manual_record .header .left p {
    font-size: 13px;
  }
  .manual_record .header .left img {
    width: 50px;
  }
  .manual_record .header {
    display: none;
  }
  .manual_record .body .header-title div .item p {
    font-size: 10px;
  }
  .manual_record .body .header-title div .item.active {
    border-bottom: #4c2e73 solid 2px;
  }

  .highchart-container {
    max-height: 250px;
    display: block;
    margin-top: 0px;
  }
  .progress-wrapper {
    background: #fff;
    margin-top: -30px;
  }
}
@media screen and (min-width: 860px) {
  .highchart-container {
    display: none;
  }
}
</style>
